<template>
  <el-dialog
    class="dialog-container"
    :title="title"
    :visible.sync="dialogVisible"
    width="880px"
    append-to-body
    destroy-on-close
  >
    <el-form ref="form" :model="form" :rules="formRules" label-width="245px">
      <!-- 第一部分：基本信息 -->
      <div>
        <div class="titleTips">
          <img src="@/assets/image/basicIcon.png" alt="" />
          <span>基本信息</span>
        </div>
        <!-- 销售订单号 -->
        <el-form-item label="销售订单号" prop="orderNum">
          <el-input v-model="form.orderNum" placeholder="请输入销售订单号" />
        </el-form-item>
        <!-- 车型 -->
        <el-form-item :label="'车型'" prop="carModel">
          <el-input v-model="form.carModel" :placeholder="'请输入车型'" />
        </el-form-item>
        <!-- 订单车辆数量 -->
        <el-form-item label="订单车辆数量" prop="carTotal">
          <el-input-number class="number-input" :controls="false" :precision="0" v-model="form.carTotal"
            placeholder="请输入订单车辆数量">
          </el-input-number>
          <div class="number-input-append">台</div>
        </el-form-item>
        <!-- 故障发生日期 -->
        <el-form-item label="故障发生日期" prop="happenDate">
          <el-date-picker type="date" value-format="yyyy-MM-dd" v-model="form.happenDate"
            placeholder="请选择故障发生日期"></el-date-picker>
        </el-form-item>
        <!-- 严重程度 -->
        <el-form-item label="严重程度" prop="issueSeverity">
          <el-select v-model="form.issueSeverity" filterable clearable>
            <el-option v-for="(item, index) in severityDataKD" :key="index" :label="item.label" :value="item.code">
              <el-tooltip placement="right" effect="light">
                <div slot="content" class="severityTips" v-html="item.desc"></div>
                <span>{{ item.label }}</span>
              </el-tooltip>
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 反馈单目的 -->
        <el-form-item label="反馈单目的" prop="feedbackPurpose">
          <el-select v-model="form.feedbackPurpose" placeholder="请选择反馈单目的" filterable multiple>
            <el-option label="质量改进" :value="'1'"></el-option>
            <el-option label="索赔备案" :value="'2'"></el-option>
            <el-option label="紧急补件" :value="'3'"></el-option>
            <el-option label="技术援助" :value="'4'"></el-option>
          </el-select>
        </el-form-item>
        <!-- 补件方式 -->
        <el-form-item v-if="form.feedbackPurpose && form.feedbackPurpose.includes('3')" label="补件方式" prop="patchMode">
          <el-select v-model="form.patchMode" placeholder="请选择补件方式" filterable clearable>
            <el-option label="紧急空运" :value="1"></el-option>
            <el-option label="随KD订单发运" :value="2"></el-option>
            <el-option label="通过配件订单发运" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <!-- 客户诉求 -->
        <el-form-item label="客户诉求" prop="customerDemand">
          <el-input
            v-model="form.customerDemand"
            type="textarea"
            placeholder="请输入客户诉求"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
        <!-- 故障配件数量 -->
        <el-form-item label="故障配件数量">
          <el-input-number disabled :controls="false" :precision="0" v-model="form.faultTotal">
          </el-input-number>
        </el-form-item>
        <!-- 故障描述 -->
        <!--      <el-form-item label="故障现象描述" prop="questionContent">-->
        <!--        <el-input-->
        <!--          v-model="form.questionContent"-->
        <!--          type="textarea"-->
        <!--          placeholder="请输入"-->
        <!--          style="width: 740px"-->
        <!--          :autosize="{ minRows: 4, maxRows: 4 }"-->
        <!--        />-->
        <!--      </el-form-item>-->
        <!-- 是否重点问题 -->
        <el-form-item label="故障来源" prop="sourceType" required>
          <el-radio-group v-model="form.sourceType">
            <el-radio :label="0">制程质量</el-radio>
            <el-radio :label="1">开箱质量</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否重点问题" prop="importantType" required>
          <el-radio-group v-model="form.importantType">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 重点问题描述 -->
        <el-form-item v-if="form.importantType === 1" label="重点问题描述" prop="importantDescribe">
          <el-input type="textarea" v-model="form.importantDescribe" placeholder="请输入重点问题描述" :autosize="{ minRows: 2, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
        </el-form-item>
        <!-- 是否有维修措施 -->
        <el-form-item label="是否有维修措施" prop="serviceMeasure" required>
          <el-radio-group v-model="form.serviceMeasure">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 客户海外KD工厂处置方案 -->
        <el-form-item label="客户海外KD工厂处置方案" prop="marketService" v-if="form.serviceMeasure == 1">
          <el-input type="textarea" v-model="form.marketService" :placeholder="'请输入客户海外KD工厂处置方案'" :autosize="{ minRows: 2, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
        </el-form-item>
        <!-- 零部件类别 -->
        <el-form-item label="零部件类别" prop="componentType">
          <el-select v-model="form.componentType" @change="$refs.tableRef.doLayout()" filterable clearable>
            <el-option v-for="(item, index) in componentCategoryList" :key="index"
              :label="item[componentCategoryName.get('zh')]" :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 故障零件号/物料代码 -->
        <div>
          <el-form-item label="故障零件号/物料代码" prop="vinCheckRespList">
            <!-- 表格内容 -->
            <div class="table-container">
              <div style="margin-bottom: 15px">
                <!-- 添加 -->
                <el-button class="primary-btn" type="primary" size="small" icon="el-icon-plus"
                  @click="handleAdd">添加</el-button>
                <!-- 批量导入 -->
                <el-button class="primary-btn" type="primary" plain icon="el-icon-upload2" size="small"
                  @click="handleImport">批量导入</el-button>
              </div>
              <el-table ref="tableRef" :border="true" stripe :data="form.vinCheckRespList">
                <!-- 外包装箱号 -->
                <el-table-column property="outBoxNo" min-width="180px" show-overflow-tooltip align="center">
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>木/铁箱编号</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item :prop="'vinCheckRespList.' + scope.$index + '.outBoxNo'"
                      :rules="{ required: true, message: '木/铁箱编号不能为空' }">
                      <el-input v-model="scope.row.outBoxNo" placeholder="请输入木/铁箱编号"/>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 纸箱号 -->
                <el-table-column property="paperNo" min-width="180px" show-overflow-tooltip align="center">
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>纸箱编号</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item :prop="'vinCheckRespList.' + scope.$index + '.paperNo'"
                      :rules="{ required: true, message: '纸箱编号编码不能为空' }">
                      <el-input v-model="scope.row.paperNo" placeholder="请输入纸箱编号" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 配件编码 -->
                <el-table-column property="faultCode" min-width="180px" align="center">
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>零件号/物料代码</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item :prop="'vinCheckRespList.' + scope.$index + '.faultCode'"
                      :rules="{ required: true, message: '零件号/物料代码不能为空' }">
                      <el-autocomplete class="table-auto-input" :ref="'autocomplete' + scope.$index"
                        v-model="scope.row.faultCode" placeholder="请输入零件号/物料代码" :fetch-suggestions="getFaultList"
                        @select="handleSelect($event, scope.$index)" @keyup.enter.native="
                          handleInput('autocomplete' + scope.$index)
                          " @blur="onBlurFault(scope.$index)"></el-autocomplete>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 配件名称 -->
                <el-table-column property="faultName" label="零件/物料名称" min-width="180px" show-overflow-tooltip
                  align="center">
                  <template slot-scope="scope">
                    <el-form-item>
                      <el-input v-model="scope.row.faultName" placeholder="请输入零件/物料名称" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 故障零件数量 -->
                <el-table-column property="faultNumber" min-width="180px" show-overflow-tooltip align="center">
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>故障零件数量</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item :prop="'vinCheckRespList.' + scope.$index + '.faultNumber'"
                      :rules="{ required: true, message: '故障零件数量不能为空' }">
                      <el-input-number :controls="false" :precision="0"
                        v-model="scope.row.faultNumber" placeholder="请输入故障零件数量">
                      </el-input-number>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 发动机型号 -->
                <el-table-column v-if="form.componentType == 1" key="engineType" property="engineType" min-width="180px"
                  align="center">
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>发动机型号</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item :prop="'vinCheckRespList.' + scope.$index + '.engineType'"
                      :rules="{ required: form.componentType == 1, message: '发动机型号不能为空' }">
                      <el-input v-model="scope.row.engineType" placeholder="请输入发动机型号" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 发动机号 -->
                <el-table-column v-if="form.componentType == 1" key="engineNo" property="engineNo" min-width="180px"
                  align="center">
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>发动机号</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item :prop="'vinCheckRespList.' + scope.$index + '.engineNo'"
                      :rules="{ required: form.componentType == 1, message: '发动机号不能为空' }">
                      <el-input v-model="scope.row.engineNo" placeholder="请输入发动机号" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 订单批次号 -->
                <el-table-column property="orderBatch" min-width="180px" show-overflow-tooltip align="center">
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>订单批次号</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item :prop="'vinCheckRespList.' + scope.$index + '.orderBatch'"
                      :rules="{ required: true, message: '订单批次号不能为空' }">
                      <el-input v-model="scope.row.orderBatch" placeholder="请输入订单批次号" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 零部件批次号 -->
                <el-table-column property="partBatchNo" min-width="180px" show-overflow-tooltip align="center">
                  <template #header>
                    <span>零部件批次号</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="
                        'vinCheckRespList.' + scope.$index + '.partBatchNo'
                      "
                    >
                      <el-input
                        v-model="scope.row.partBatchNo"
                        placeholder="请输入零部件批次号"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 供应商代码 -->
                <el-table-column property="supplierCode" min-width="180px" align="center">
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>供应商代码</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item :prop="'vinCheckRespList.' + scope.$index + '.supplierCode'"
                      :rules="{ required: true, message: '供应商代码不能为空' }">
                      <el-input v-model="scope.row.supplierCode" placeholder="请输入供应商代码" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 故障类别 -->
                <el-table-column property="faultType" min-width="180px" show-overflow-tooltip align="center">
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>故障类别</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item :prop="'vinCheckRespList.' + scope.$index + '.faultType'"
                      :rules="{ required: true, message: '故障类别不能为空' }">
                      <el-select v-model="scope.row.faultType" placeholder="请选择故障类别" filterable clearable>
                        <el-option v-for="(item, index) in kdFaultTypeList.filter(
                          item => item.codeText === 'zh'
                        )" :key="index" :label="item.value" :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 维修方案 -->
                <el-table-column property="repairPlan" min-width="180px" show-overflow-tooltip align="center">
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>维修方案</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item :prop="'vinCheckRespList.' + scope.$index + '.repairPlan'"
                      :rules="{ required: true, message: '维修方案不能为空' }">
                      <el-select v-model="scope.row.repairPlan" placeholder="请选择维修方案" filterable clearable>
                        <el-option v-for="(item, index) in kdRepairPlanList.filter(
                          item => item.codeText === 'zh'
                        )" :key="index" :label="item.value" :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 单车用量 -->
                <el-table-column property="singleDosage" label="单车用量" min-width="180px" show-overflow-tooltip
                  align="center">
                  <template slot-scope="scope">
                    <el-form-item>
                      <el-input-number class="number-input" :controls="false" :precision="0"
                        v-model="scope.row.singleDosage" placeholder="请输入单车用量">
                      </el-input-number>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 到港时间 -->
                <el-table-column property="arrivalTime" min-width="180px" align="center">
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>到港时间</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item :prop="'vinCheckRespList.' + scope.$index + '.arrivalTime'"
                      :rules="{ required: true, message: '到港时间不能为空' }">
                      <el-date-picker v-model="scope.row.arrivalTime" type="date" value-format="yyyy-MM-dd"
                        placeholder="请选择到港时间"></el-date-picker>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 开箱时间 -->
                <el-table-column property="unboxingTime" min-width="180px" align="center">
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>开箱时间</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item :prop="'vinCheckRespList.' + scope.$index + '.unboxingTime'"
                      :rules="{ required: true, message: '开箱时间不能为空' }">
                      <el-date-picker v-model="scope.row.unboxingTime" type="date" value-format="yyyy-MM-dd"
                        placeholder="请选择开箱时间"></el-date-picker>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 上线时间 -->
                <el-table-column property="onlineTime" min-width="180px" align="center">
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>上线时间</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item :prop="'vinCheckRespList.' + scope.$index + '.onlineTime'"
                      :rules="{ required: true, message: '上线时间不能为空' }">
                      <el-date-picker v-model="scope.row.onlineTime" type="date" value-format="yyyy-MM-dd"
                        placeholder="请选择上线时间"></el-date-picker>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 操作 -->
                <el-table-column label="操作" align="center" width="90px">
                  <template slot-scope="scope">
                    <!-- 删除 -->
                    <el-button size="mini" type="text" @click="handleDelete(scope.row, scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
        </div>
      </div>

      <!-- 问题描述 -->
      <div>
        <div class="titleTips">
          <img src="@/assets/image/wtmsIcon.png" alt="" />
          问题描述
        </div>
        <!-- 故障现象描述 -->
        <el-form-item :label="'故障现象描述'" prop="questionContent">
          <el-input  type="textarea" v-model="form.questionContent" :placeholder="'请输入故障现象描述'" :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500" show-word-limit />
        </el-form-item>
        <!-- 附件 -->
        <!-- <el-form-item :label="'附件'"> -->
        <!-- <drag-upload :accessory-list.sync="form.questionDescriptionAndFiles.faultDescriptionList"
                         :httpRequest="action" uploadType="paste"></drag-upload> -->
        <!--            <div class="el-upload__tip" style="line-height: 1.5; margin-top: 5px;">-->
        <!--              支持上传 jpg,png,mp3,mp4,xls,xlsx,doc,docx,zip格式的文件，且文件数量不超过5个，单个文件大小不能超过100M-->
        <!--            </div>-->
        <!-- </el-form-item> -->
      </div>

      <!-- 图片和视频 -->
      <div>
        <div class="titleTips">
          <img src="@/assets/image/ImgIcon.png" alt="" />
          图片和视频
        </div>
        <fileUploadTips></fileUploadTips>
        <!-- 包装箱拆箱前整体图片/视频 -->
        <div class="radio-upload-group">
          <el-form-item label="包装箱拆箱前整体图片/视频" prop="questionDescriptionAndFiles.isUnboxOverall" required>
            <el-radio-group v-model="form.questionDescriptionAndFiles.isUnboxOverall">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.questionDescriptionAndFiles.isUnboxOverall === 1" label="附件"
            prop="questionDescriptionAndFiles.unboxOverallList">
            <drag-upload :accessory-list.sync="form.questionDescriptionAndFiles.unboxOverallList"
              :httpRequest="action" :tipStatus="false"></drag-upload>
          </el-form-item>
        </div>

        <!-- 包装箱粘贴标签图片 -->
        <div class="radio-upload-group">
          <el-form-item label="包装箱粘贴标签图片" prop="questionDescriptionAndFiles.isBoxLabel" required>
            <el-radio-group v-model="form.questionDescriptionAndFiles.isBoxLabel">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.questionDescriptionAndFiles.isBoxLabel === 1" label="附件"
            prop="questionDescriptionAndFiles.boxLabelList">
            <drag-upload :accessory-list.sync="form.questionDescriptionAndFiles.boxLabelList"
              :httpRequest="action" :tipStatus="false"></drag-upload>
          </el-form-item>
        </div>

        <!-- 包装箱损坏局部图片/视频 -->
        <div class="radio-upload-group">
          <el-form-item label="包装箱损坏局部图片/视频" prop="questionDescriptionAndFiles.isBoxDamage" required>
            <el-radio-group v-model="form.questionDescriptionAndFiles.isBoxDamage">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.questionDescriptionAndFiles.isBoxDamage === 1" label="附件"
            prop="questionDescriptionAndFiles.boxDamageList">
            <drag-upload :accessory-list.sync="form.questionDescriptionAndFiles.boxDamageList"
              :httpRequest="action" :tipStatus="false"></drag-upload>
          </el-form-item>
        </div>

        <!-- 零部件整体图片 -->
        <div class="radio-upload-group">
          <el-form-item label="零部件整体图片" prop="questionDescriptionAndFiles.isPartOverall" required>
            <el-radio-group v-model="form.questionDescriptionAndFiles.isPartOverall">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.questionDescriptionAndFiles.isPartOverall === 1" label="附件"
            prop="questionDescriptionAndFiles.partOverallList">
            <drag-upload :accessory-list.sync="form.questionDescriptionAndFiles.partOverallList"
              :httpRequest="action" :tipStatus="false"></drag-upload>
          </el-form-item>
        </div>

        <!-- 零部件局部图片/视频 -->
        <div class="radio-upload-group">
          <el-form-item label="零部件局部图片/视频" prop="questionDescriptionAndFiles.isPartDetail" required>
            <el-radio-group v-model="form.questionDescriptionAndFiles.isPartDetail">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.questionDescriptionAndFiles.isPartDetail === 1" label="附件"
            prop="questionDescriptionAndFiles.partDetailList">
            <drag-upload :accessory-list.sync="form.questionDescriptionAndFiles.partDetailList"
              :httpRequest="action" :tipStatus="false"></drag-upload>
          </el-form-item>
        </div>

        <!-- 零部件对比图片(错/漏发/状态不对) -->
        <div class="radio-upload-group">
          <el-form-item label="零部件对比图片(错/漏发/状态不对)" prop="questionDescriptionAndFiles.isPartComparison" required>
            <el-radio-group v-model="form.questionDescriptionAndFiles.isPartComparison" >
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.questionDescriptionAndFiles.isPartComparison === 1" label="附件"
            prop="questionDescriptionAndFiles.partComparisonList">
            <drag-upload :accessory-list.sync="form.questionDescriptionAndFiles.partComparisonList"
              :httpRequest="action" :tipStatus="false"></drag-upload>
          </el-form-item>
        </div>

        <!-- 供应商信息图片 -->
        <div class="radio-upload-group">
          <el-form-item label="供应商信息图片" prop="questionDescriptionAndFiles.isSupplierInfo" required>
            <el-radio-group v-model="form.questionDescriptionAndFiles.isSupplierInfo">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.questionDescriptionAndFiles.isSupplierInfo === 1" label="附件"
            prop="questionDescriptionAndFiles.supplierInfoList">
            <drag-upload :accessory-list.sync="form.questionDescriptionAndFiles.supplierInfoList"
              :httpRequest="action" :tipStatus="false"></drag-upload>
          </el-form-item>
        </div>

        <!-- 其他辅助证据/视频资料 -->
        <div class="radio-upload-group">
          <el-form-item label="其他辅助证据/视频资料" prop="questionDescriptionAndFiles.isOtherEvidence" required>
            <el-radio-group v-model="form.questionDescriptionAndFiles.isOtherEvidence">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="form.questionDescriptionAndFiles.isOtherEvidence === 1">
            <el-form-item label="备注" prop="questionDescriptionAndFiles.remark">
              <el-input type="textarea" v-model="form.questionDescriptionAndFiles.remark" placeholder="请输入备注"
                :autosize="{ minRows: 2, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="附件" prop="questionDescriptionAndFiles.otherEvidenceList">
              <drag-upload :accessory-list.sync="form.questionDescriptionAndFiles.otherEvidenceList"
                :httpRequest="action" :tipStatus="false"></drag-upload>
            </el-form-item>
          </template>
        </div>
      </div>

    </el-form>
    <div slot="footer" class="dialog-footer-button">
      <el-button type="primary" @click="handleSave">
        提交
      </el-button>
      <el-button type="primary" plain @click="dialogVisible = false">取消</el-button>
    </div>
    <import-model-dialog ref="importModelDialog" :uploadUrl="uploadUrl"
      templateUrl="https://shineray-dev-oversea.oss-cn-chengdu.aliyuncs.com/importTemplate/kdQuesionFault/故障配件导入模板.xlsx"
      @success="getList" />
  </el-dialog>
</template>

<script>
import { problemAddApi, problemEditApi } from "@/api/feedbackKD";
import { getECPData } from "@/api/seek";
import ImportModelDialog from "@/components/importModelDialog.vue";
import { uploadUrl } from "@/util/url";
import { getDictItem } from "@/util/dict";
import CryptoJS from "crypto-js";
import componentConfig from "@/mixins/componentConfig";
import fileUploadTips from "@/components/fileUpload/fileUploadTips.vue";
import { getStorage } from "@/util/localStor";
export default {
  props: {},
  mixins: [componentConfig],
  components: { ImportModelDialog, fileUploadTips },
  data() {
    return {
      action: "/manage/saleChannelController/upload/file",
      kdFaultTypeList: [], // 故障类型列表
      kdRepairPlanList: [], // 维修方案列表
      faultList: [], // 配件编码列表
      title: "", // 弹窗标题
      dialogVisible: false, // 弹窗显示
      form: this.getForm(), // 表单数据
      uploadUrl: uploadUrl + "/manage/kd/feedback/question/importFault" // 导入地址
    };
  },
  computed: {
    // 表单验证规则
    formRules() {
      // 公共规则配置
      const commonRule = {
        required: true,
        trigger: ["change", "blur"]
      };
      // 文件类字段的通用规则
      const createRule = (fieldName) => [
        { ...commonRule, message: `${fieldName}不能为空` },
      ];
      // 文件类字段的通用规则
      const createFileRule = (fieldName) => [
        { ...commonRule, message: `${fieldName}附件不能为空` },
      ];
      return {
        orderNum: createRule("销售订单号"),
        carModel: createRule("车型"),
        carTotal: createRule("订单车辆数量"),
        happenDate: createRule("故障发生日期"),
        issueSeverity:createRule("严重程度"),
        feedbackPurpose: createRule("反馈单目的"),
        customerDemand:createRule("客户诉求"),
        // patchMode: [
        //   {
        //     validator: (rule, value, callback) => {
        //       if (Array.isArray(this.form.feedbackPurpose) && this.form.feedbackPurpose.includes('3') && !value) {
        //         callback(new Error("补件方式不能为空"));
        //       } else {
        //         callback();
        //       }
        //     },
        //     required: true,
        //     trigger: "change",
        //   },
        // ],
        importantDescribe: createRule("重点问题描述"),
        marketService: createRule("客户海外KD工厂处置方案"),
        componentType: createRule("零部件类别"),
        vinCheckRespList:createRule("故障零件号/物料代码"),
        questionContent: createRule("故障现象描述" ),
        ...Object.fromEntries([
          ['unboxOverallList', '包装箱拆箱前整体图片/视频'],
          ['boxLabelList', '包装箱粘贴标签图片'],
          ['boxDamageList', '包装箱损坏局部图片/视频'],
          ['partOverallList', '零部件整体图片'],
          ['partDetailList', '零部件局部图片/视频'],
          ['partComparisonList', '零部件对比图片(错/漏发/状态不对)'],
          ['supplierInfoList', '供应商信息图片'],
          ['otherEvidenceList', '其他辅助证据/视频资料']
        ].map(([key, name]) => [
          `questionDescriptionAndFiles.${key}`,
          [{ ...commonRule, message: `${name}附件不能为空` }]
        ])),
        "questionDescriptionAndFiles.remark": [{...commonRule, message: "其他辅助证据/视频资料备注不能为空" }],
      }
    }
  },
  created() {
    this.getkdFaultTypeList();
    this.getkdRepairPlanList();
    this.getTypeList();
  },
  watch: {
    "form.vinCheckRespList": {
      deep: true,
      handler(val) {
        this.form.faultTotal = 0;
        val.map((item, index) => {
          this.form.faultTotal += item.faultNumber || 0;
        });
      }
    }
  },
  methods: {
    // 获取车型列表
    async getkdFaultTypeList() {
      const res = await getDictItem("kdFaultType");
      this.kdFaultTypeList = res || [];
    },
    // 获取维修方案
    async getkdRepairPlanList() {
      const res = await getDictItem("kdRepairPlan");
      this.kdRepairPlanList = res || [];
    },
    // 初始化
    async init(title, data = {}, qualityData) {
      this.title = title;
      this.dialogVisible = true;
      this.form = this.getForm(data, qualityData);
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    // 获取表单对象
    getForm(data = {}, qualityData = {}) {
      const customer = getStorage("qualityData");
      let qdf = {};
      try {
        if (data.questionDescriptionAndFiles && typeof data.questionDescriptionAndFiles === 'string') {
          qdf = JSON.parse(data.questionDescriptionAndFiles);
        } else if (data.questionDescriptionAndFiles && typeof data.questionDescriptionAndFiles === 'object') {
          qdf = data.questionDescriptionAndFiles;
        }
      } catch (e) {
        console.error("Failed to parse questionDescriptionAndFiles", e);
      }
      return {
        countryDataId: data.countryDataId || customer.countryDataId,
        carType: data.carType || customer.carType,
        feedbackFormId: data.feedbackFormId || "",
        questionId: data.questionId || "",
        orderNum: data.orderNum || "",
        carTotal: data.carTotal || undefined,
        happenDate: data.happenDate || "",
        faultTotal: data.faultTotal || undefined,
        questionContent: data.questionContent || "",
        serviceMeasure: data.serviceMeasure ?? 0,
        issueSeverity: data.issueSeverity || "",
        carModel: data.carModel || "",
        feedbackPurpose: data.feedbackPurpose ? String(data.feedbackPurpose).split(",") : undefined,
        patchMode: data.patchMode || undefined,
        customerDemand: data.customerDemand || "",
        componentType: data.componentType ?? undefined,
        marketService: data.marketService || "",
        importantType: data.importantType ?? 1,
        sourceType: data.sourceType ?? 0,
        importantDescribe: data.importantDescribe || "",
        questionDescriptionAndFiles: {
          faultDescription: qdf.faultDescription || data.faultDescription || "",
          faultDescriptionList: qdf.faultDescriptionList || data.faultDescriptionList || [],
          isUnboxOverall: qdf.isUnboxOverall ?? data.isUnboxOverall ?? 1,
          unboxOverallList: qdf.unboxOverallList || data.unboxOverallList || [],
          isBoxLabel: qdf.isBoxLabel ?? data.isBoxLabel ?? 1,
          boxLabelList: qdf.boxLabelList || data.boxLabelList || [],
          isBoxDamage: qdf.isBoxDamage ?? data.isBoxDamage ?? 1,
          boxDamageList: qdf.boxDamageList || data.boxDamageList || [],
          isPartOverall: qdf.isPartOverall ?? data.isPartOverall ?? 1,
          partOverallList: qdf.partOverallList || data.partOverallList || [],
          isPartDetail: qdf.isPartDetail ?? data.isPartDetail ?? 1,
          partDetailList: qdf.partDetailList || data.partDetailList || [],
          isPartComparison: qdf.isPartComparison ?? data.isPartComparison ?? 1,
          partComparisonList: qdf.partComparisonList || data.partComparisonList || [],
          isSupplierInfo: qdf.isSupplierInfo ?? data.isSupplierInfo ?? 1,
          supplierInfoList: qdf.supplierInfoList || data.supplierInfoList || [],
          isOtherEvidence: qdf.isOtherEvidence ?? data.isOtherEvidence ?? 1,
          otherEvidenceList: qdf.otherEvidenceList || data.otherEvidenceList || [],
          remark: qdf.remark || data.remark || "",
        },
        vinCheckRespList: data.vinCheckRespList
          ? JSON.parse(JSON.stringify(data.vinCheckRespList))
          : [],
        delList: [] // 删除故障配件列表记录
      };
    },
    // 获取ECP接口参数
    getECPParams() {
      const appId = "586738eb-49ed-4289-b951-193bfee3452b";
      const authToken = "298714f9-b43c-4772-b259-e6e2728cbd91";
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now
        .getDate()
        .toString()
        .padStart(2, "0");
      const hours = now
        .getHours()
        .toString()
        .padStart(2, "0");
      const minutes = now
        .getMinutes()
        .toString()
        .padStart(2, "0");
      const seconds = now
        .getSeconds()
        .toString()
        .padStart(2, "0");
      const timestamp =
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;
      // 拼接appId、authToken和timestamp三个参数后，进行MD5摘要得到16进制摘要字符串，然后转大写得到签名
      const concat = appId + authToken + timestamp;
      const sign = CryptoJS.MD5(concat)
        .toString()
        .toUpperCase();
      return { appId, timestamp, sign };
    },
    // 根据故障件件号（配件编码），EPC系统获取故障件（配件）
    async getFault(queryString) {
      const { appId, timestamp, sign } = this.getECPParams();
      const params = {
        appId,
        timestamp,
        sign,
        codeList: [queryString],
        account: this.form.customerAccountNum
      };
      const res = await getECPData(params);
      const faultList = res.data;
      return faultList;
    },
    // 获取故障件列表
    async getFaultList(queryString, cb) {
      if (queryString && queryString.length >= 7) {
        const faultList = await this.getFault(queryString);
        this.faultList = [];
        faultList?.map(item => {
          this.faultList.push({ ...item, zh: item.name, value: item.code });
        });
      } else {
        this.faultList = [];
      }
      cb(this.faultList);
    },
    // 输入故障件
    handleInput(ref) {
      this.$refs[ref].$refs.input.blur(); // 取消焦点
      this.$refs[ref].activated = false; // 关闭下拉框
    },
    // 表格输入故障件获取数据
    async onBlurFault(index) {
      if (
        this.faultList.length === 0 &&
        this.form.vinCheckRespList[index].faultCode.length >= 7
      ) {
        const faultList = await this.getFault(
          this.form.vinCheckRespList[index].faultCode
        );
        this.faultList = [];
        faultList?.map(item => {
          this.faultList.push({ ...item, zh: item.name, value: item.code });
        });
      }
      const faultIndex = this.faultList.findIndex(item => {
        return item.code === this.form.vinCheckRespList[index].faultCode;
      });
      if (faultIndex !== -1) {
        this.form.vinCheckRespList[index].faultName = this.faultList[
          faultIndex
        ].zh;
      }
    },
    // 选择故障件
    handleSelect(item, index) {
      this.form.vinCheckRespList[index].faultName = item.zh;
    },
    // 添加故障件
    handleAdd() {
      this.form.vinCheckRespList.unshift({
        outBoxNo: "",
        paperNo: "",
        faultCode: "",
        faultName: "",
        orderBatch: "",
        faultNumber: undefined,
        faultType: "",
        repairPlan: "",
        singleDosage: undefined
      });
    },
    // 删除故障件
    handleDelete({ id }, index) {
      id && this.form.delList.push({ id: id });
      this.form.vinCheckRespList.splice(index, 1);
    },
    // 批量导入故障件
    handleImport() {
      this.$refs.importModelDialog.init("批量导入");
    },
    // 导入成功列表
    getList(data) {
      this.form.vinCheckRespList = [...this.form.vinCheckRespList, ...data];
    },
    // 图片和视频校验附件
    getCheckList() {
      const checkList = [
        {
          is: "isUnboxOverall",
          list: "unboxOverallList",
          label: "restock.isUnboxOverall",
        },
        {
          is: "isBoxLabel",
          list: "boxLabelList",
          label: "restock.isBoxLabel",
        },
        {
          is: "isBoxDamage",
          list: "boxDamageList",
          label: "restock.isBoxDamage",
        },
        {
          is: "isPartOverall",
          list: "partOverallList",
          label: "restock.isPartOverall",
        },
        {
          is: "isPartDetail",
          list: "partDetailList",
          label: "restock.isPartDetail",
        },
        {
          is: "isPartComparison",
          list: "partComparisonList",
          label: "restock.isPartComparison",
        },
        {
          is: "isSupplierInfo",
          list: "supplierInfoList",
          label: "restock.isSupplierInfo",
        },
        {
          is: "isOtherEvidence",
          list: "remark",
          label: "restock.isOtherEvidence",
        },
        {
          is: "isOtherEvidence",
          list: "otherEvidenceList",
          label: "restock.isOtherEvidence",
        },
      ];
      return checkList;
    },
    // 保存
    handleSave() {
      this.$refs.form.validate(async(valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        try {
          const submitData = JSON.parse(JSON.stringify(this.form));
          Array.isArray(submitData.feedbackPurpose) && (submitData.feedbackPurpose = submitData.feedbackPurpose.join(","));
          submitData.importantType == 0 && (submitData.importantDescribe = "");
          submitData.serviceMeasure == 0 && (submitData.marketService = "");
          var checkList = this.getCheckList();
          checkList.forEach((item) => {
            if (submitData.questionDescriptionAndFiles[item.is] == 0) {
              if (item.list == "remark") {
                submitData.questionDescriptionAndFiles[item.list] = ""
              } else {
                submitData.questionDescriptionAndFiles[item.list] = []
              }
            }
          })
          submitData.questionDescriptionAndFiles = JSON.stringify(submitData.questionDescriptionAndFiles);
          submitData.vinCheckRespList.map((item, index) => {
            submitData.vinCheckRespList[index].faultTypeZh = item.faultType;
            submitData.vinCheckRespList[index].repairPlanZh = item.repairPlan;
          });
          let res = {};
          if (submitData.questionId) {
            res = await problemEditApi({ data: submitData });
          } else {
            res = await problemAddApi({ data: submitData });
          }
          if (res.status == 0) {
            this.dialogVisible = false;
            this.$DonMessage.success("提交成功");
            this.$emit("success", res.data);
          } else {
            this.$DonMessage.error(res.message);
          }
        } catch (error) {
          console.error(error);
        }
      });
    }
  }
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
